export default "__VITE_ASSET__oIyxCrsi__"